import { type ReactNode, useCallback, useState } from 'react'

import { type CustomField } from '@webapp/core/entities/internal/CustomField'
import { useQueryPOCustomFieldConfigs } from '@webapp/modules/purchasing/features/list-po-custom-field-configs/models'

const PAGE_SIZE = 10

export interface UsePOCustomFieldConfigListPresenterParams {
  /** Optional to support headless companion use by the Feature Set */
  onDeleteField?: (field: CustomField) => void
  renderNameCell?: (field: CustomField) => ReactNode
}

export const usePOCustomFieldConfigListPresenter = (
  _params: UsePOCustomFieldConfigListPresenterParams = {}
) => {
  const [page, setPage] = useState(1)

  const { fields, pagination, isLoading, isFetching } =
    useQueryPOCustomFieldConfigs({
      page,
      pageSize: PAGE_SIZE,
    })

  const onPrevPage = useCallback(() => {
    setPage((currentPage) => Math.max(1, currentPage - 1))
  }, [])

  const onNextPage = useCallback(() => {
    setPage((currentPage) =>
      pagination.numPages > 0
        ? Math.min(pagination.numPages, currentPage + 1)
        : currentPage
    )
  }, [pagination.numPages])

  return {
    data: {
      fields,
      totalCount: pagination.count,
      numPages: pagination.numPages,
    },
    states: {
      page,
      isLoading,
      isFetching,
    },
    methods: {
      onPrevPage,
      onNextPage,
    },
  }
}
